const STORAGE_KEY = 'nebula_printer_device';

export function isBluetoothSupported() {
  return typeof navigator !== 'undefined' && !!navigator.bluetooth;
}

export function getSavedPrinter() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
  } catch {
    return null;
  }
}

export async function connectPrinter() {
  if (!isBluetoothSupported()) throw new Error('Bluetooth no soportado');
  const device = await navigator.bluetooth.requestDevice({
    acceptAllDevices: true,
    optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb'],
  });
  const info = { id: device.id, name: device.name || 'Impresora' };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(info));
  return info;
}

function escPosTicket(lines) {
  const encoder = new TextEncoder();
  const parts = [];
  // init
  parts.push(new Uint8Array([0x1b, 0x40]));
  for (const line of lines) {
    parts.push(encoder.encode(line + '\n'));
  }
  // cut
  parts.push(new Uint8Array([0x1d, 0x56, 0x00]));
  const total = parts.reduce((n, p) => n + p.length, 0);
  const out = new Uint8Array(total);
  let off = 0;
  for (const p of parts) {
    out.set(p, off);
    off += p.length;
  }
  return out;
}

export async function printTicket(textLines) {
  if (!isBluetoothSupported()) return false;
  const device = await navigator.bluetooth.requestDevice({
    acceptAllDevices: true,
    optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb'],
  });
  const server = await device.gatt.connect();
  // try common service/characteristic
  const services = await server.getPrimaryServices();
  let char = null;
  for (const svc of services) {
    const chars = await svc.getCharacteristics();
    for (const c of chars) {
      if (c.properties.write || c.properties.writeWithoutResponse) {
        char = c;
        break;
      }
    }
    if (char) break;
  }
  if (!char) throw new Error('No se encontró característica de escritura');
  const data = escPosTicket(textLines);
  const chunkSize = 20;
  for (let i = 0; i < data.length; i += chunkSize) {
    const chunk = data.slice(i, i + chunkSize);
    if (char.properties.writeWithoutResponse) {
      await char.writeValueWithoutResponse(chunk);
    } else {
      await char.writeValue(chunk);
    }
  }
  return true;
}
